import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.classList.add("dark");
    if (user) navigate("/", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username.trim(), password);
      toast.success("Welcome to PLUTUS");
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background text-foreground">
      <div className="hidden md:flex relative overflow-hidden">
        <div className="absolute inset-0" style={{
          background: "radial-gradient(ellipse at 30% 20%, rgba(201,168,118,0.15), transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(201,168,118,0.08), transparent 55%), #141311"
        }} />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="flex items-center gap-4">
            <img src="/plutus_logo.png" className="h-14 w-14 object-contain" alt="PLUTUS" />
            <div>
              <div className="font-serif text-4xl tracking-tight" style={{ color: "#C9A876" }}>PLUTUS</div>
              <div className="overline mt-1">Employee Advance Ledger</div>
            </div>
          </div>
          <div>
            <h1 className="font-serif text-5xl leading-tight text-white/90">A private ledger for<br/>every rupee advanced.</h1>
            <p className="mt-5 text-white/60 max-w-md">Track advances, monthly deductions, additional repayments, and bad debts across branches. Interest-free. Owner-only. Precise.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
          <div className="md:hidden flex items-center gap-3 mb-4">
            <img src="/plutus_logo.png" className="h-10 w-10 object-contain" alt="PLUTUS" />
            <div className="font-serif text-3xl gold">PLUTUS</div>
          </div>
          <div>
            <h2 className="font-serif text-3xl">Owner sign in</h2>
            <p className="text-sm text-muted-foreground mt-1">Access is restricted to the PLUTUS owner.</p>
          </div>
          <div>
            <Label>Username</Label>
            <Input value={username} onChange={(e) => setUsername(e.target.value)} data-testid="login-username" autoFocus autoComplete="username" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" autoComplete="current-password" />
          </div>
          <Button type="submit" className="w-full gold-bg hover:opacity-90 transition-opacity" data-testid="login-submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
